import React, { Component } from "react";
import { FaFacebookF, FaInstagram , FaYoutube, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FiX , FiMenu} from "react-icons/fi";
import Scrollspy from 'react-scrollspy'

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/AmbientVisions.tv'},
    //{Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/ambientvisions'},
    {Social: <FaTiktok /> , link: 'https://www.tiktok.com/@ambientvisions'},
    {Social: <FaYoutube /> , link: 'https://www.youtube.com/channel/UC2rTUYo_6VXy1opKuh6FeFA'},
    {Social: <FaXTwitter /> , link: 'https://twitter.com/ambient_visions'}
]

class HeaderThree extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded');
        })
        
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }

    stickyHeader () {}

    render(){

        window.addEventListener('scroll', function() {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            }else{
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { color='default-color' } = this.props;
        
        return(
            <header className={`header-area header-style-two header--fixed ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-top">
                        <div className="logo d-flex align-items-center">
                            <a href={this.props.homeLink}>
                                <img src="/assets/images/logo/av-108.png" className="img-fluid" alt="Ambient Visions" />
                            </a>
                        </div>
                        <nav className="mainmenunav d-lg-block ml--50">
                            <Scrollspy className="mainmenu" items={['divAmbientVisions','divVideo','divAboutUs','divContact']} currentClassName="is-current" offset={-200}>
                                <li><a href="/" >Ambient Visions</a></li>
                                <li><a href="/#video" >Video</a></li>
                                <li><a href="#about" >About</a></li>
                                <li><a href="#contact" >Contact</a></li>
                            </Scrollspy>
                        </nav>
                    </div>
                    <div className="header-right h-100 align-items-top">
                        <div className="social-share-inner">
                            <ul className="social-share social-style--2 d-flex justify-content-start liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`} target="_blank">{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                        <div className="header-btn">
                            <a className="rn-btn" href="https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.b04ff805-8b00-49a9-aa61-e774ee05cd1a/launch" target="_blank">
                                <span>Alexa, open Ambient Visions</span>
                            </a>
                        </div>
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default HeaderThree;